import styled from 'styled-components';

import {flexColumn, flexCenterVertically} from '~/shared/theme/FlexLayout';

import {getLocalizationService} from '../services/localisationService';
import {flipOnLTR} from '../theme/utils';
import {Link} from '../router';
import {body12Normal, body13Normal, body14Normal, body14Bold} from '../theme/typography';

import _FormField from './FormField';

const TextLink = styled(Link)`
  cursor: pointer;
  color: ${({theme}) => theme.colors.surfacePrimaryAction};
  ${({isGov}) => (isGov ? body14Bold : body12Normal)}
  line-height: 1em;
  ${({isGov}) => !isGov && 'text-decoration: underline;'}
  white-space: nowrap;
  ${flipOnLTR`
    margin-left: 3px;
  `}
  ${({isCapitalized}) => isCapitalized && `
    text-transform: capitalize;
  `}
`;

const ErrorText = styled.div.attrs(() => ({
  role: 'alert',
}))`
  ${body13Normal}
  line-height: 1em;
  color: ${({theme}) => theme.colors.error};
  ${flipOnLTR`
    text-align: right;
  `}
`;

const CheckBoxArea = styled.div`
  ${flexColumn}
  ${({isGov, theme}) => !isGov && `height: ${!theme.isLTR ? 74 : 86}px;`}
  margin-bottom: 10px;
  ${({isGov}) => isGov && `
    margin: 16px 0;
  `}
`;

const FormField = styled(_FormField).attrs({
  className: 'agree-to-terms-form-field',
})`
  display: flex;
  height: auto;
  margin-bottom: ${({isGov}) => (isGov ? '16px' : '8px')};
  flex: 0 1 auto;
`;

const Label = styled.label`
  white-space: nowrap;
  color: ${({theme}) => theme.colors.secondary};
  ${({isGov}) => (isGov ? body14Normal : body12Normal)}
  line-height: 16px;
  text-align: start;
  ${flipOnLTR`
    margin-left: 3px;
  `}
`;

const LabelWrapper = styled.div`
  flex-wrap: wrap;
  ${flexCenterVertically}
`;

export default function AgreeToTermsSection({
  errorText,
  onTermsOfUseClick,
  onPrivacyPolicyClick,
  onDealsPolicyClick,
  isUpdateUserDetails = false,
  isGov = false,
}) {
  /**
   * wantPromotion - used by signUp (nextApi)
   * wantPromotions - used by update user details (bff)
   * isUpdateUserDetails is temp solution until both signUp will be moved to the bff.
   */
  const {t, currentLanguageKey} = getLocalizationService();
  return (
    <CheckBoxArea className="checkbox-area" isGov={isGov}>
      <FormField
        {...{
          name: isUpdateUserDetails ? 'wantPromotions' : 'wantPromotion',
          type: 'checkbox',
          inputProps: {label: <Label isGov={isGov}>{t('i_want_to_recieve_deals_and_promotions')}</Label>},
          isGov,
        }}
      />

      <FormField
        {...{
          name: 'agreeToTerms',
          type: 'checkbox',
          shouldShowError: false,
          required: true,
          isGov,
          inputProps: {
            alignItems: 'start',
            label: (
              <LabelWrapper>
                <Label isGov={isGov}>{t('i_read_understood_and_agreed')}</Label>
                <TextLink currentLanguage={currentLanguageKey} onClick={onTermsOfUseClick} isGov={isGov}>
                  {t('terms_of_use')}
                </TextLink>
                <Label isGov={isGov}>{t('and')}</Label>
                {isGov ? (
                  <TextLink
                    currentLanguage={currentLanguageKey}
                    onClick={onDealsPolicyClick}
                    isCapitalized
                    isGov={isGov}
                  >
                    {t('deals_policy')}
                  </TextLink>
                ) : (
                  <TextLink
                    currentLanguage={currentLanguageKey}
                    onClick={onPrivacyPolicyClick}
                    isCapitalized
                    isGov={isGov}
                  >
                    {t('privacy_policy')}
                  </TextLink>
                )}
              </LabelWrapper>
            ),
          },
        }}
      />
      {errorText && <ErrorText>{errorText}</ErrorText>}
    </CheckBoxArea>
  );
}
